import type { DayRoute, DayName } from "../lib/schedule"
import { DAY_LABELS } from "../lib/schedule"
import { RouteCard } from "./RouteCard"

interface DaySlotProps {
  day: DayName
  route?: DayRoute
}

export function DaySlot({ day, route }: DaySlotProps) {
  const label = DAY_LABELS[day]

  return (
    <article className="min-h-[200px] w-full">
      <div className="flex flex-col items-center gap-brew-1 pb-brew-3 text-center">
        <h3 className="text-2xl leading-tight font-logo">{label}</h3>
      </div>
      {!route?.title ? (
        <div className="grid min-h-[180px] place-items-center rounded-brew-md border border-dashed border-brew-border bg-brew-surface-warm p-brew-8 px-brew-6 text-center text-brew-base font-medium text-brew-muted">
          No route posted for {label} yet.
        </div>
      ) : (
        <RouteCard day={day} route={route} />
      )}
    </article>
  )
}
